import { Box, Skeleton, Theme } from "@outschool/backpack";
import React from "react";

import { SELLER_ORG_LANDING_SKELETON as layout } from "../../../shared/SellerOrgLandingSkeletonGeometry";
import { TEACHER_DASHBOARD_SKELETON_GEOMETRY } from "../../../shared/TeacherDashboardSkeletonGeometry";
import HeaderLogo from "../nav/HeaderLogo";

const { header } = TEACHER_DASHBOARD_SKELETON_GEOMETRY;

export default function SellerOrgLandingSkeleton() {
  return (
    <Box aria-busy={true}>
      <Box sx={{ backgroundColor: "common.white" }}>
        <Box
          flex
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            gap: `${header.gap}px`,
            height: `${header.height}px`,
            marginX: "auto",
            maxWidth: `${header.maxWidth}px`,
            width: `calc(100% - ${header.horizontalMargin * 2}px)`,
          }}
        >
          <HeaderLogo />
          <Box
            flex
            sx={(theme: Theme) => ({
              alignItems: "center",
              gap: "24px",
              [theme.breakpoints.down("md")]: { display: "none" },
            })}
          >
            {layout.navItemWidths.map(width => (
              <Skeleton key={width} variant="text" width={width} height={28} />
            ))}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: layout.heroBackground,
          paddingY: { xs: "64px", sm: "96px" },
          paddingX: { xs: "16px", sm: "32px" },
        }}
      >
        <Box
          sx={(theme: Theme) => ({
            display: "grid",
            alignItems: "center",
            gap: `${layout.heroGap}px`,
            maxWidth: `${layout.contentMaxWidth}px`,
            marginX: "auto",
            [theme.breakpoints.up("md")]: {
              gridTemplateColumns: "1fr 1fr",
            },
          })}
        >
          <Box>
            <Skeleton
              variant="rounded"
              width={200}
              height={28}
              sx={{ borderRadius: "999px" }}
            />
            <Box sx={{ marginTop: "20px" }}>
              {layout.titleLineWidths.map(width => (
                <Skeleton
                  key={width}
                  variant="text"
                  width={width}
                  sx={{ fontSize: layout.heroTitleFontSize }}
                />
              ))}
            </Box>
            <Box sx={{ marginTop: "24px" }}>
              {layout.bodyLineWidths.map(width => (
                <Skeleton
                  key={width}
                  variant="text"
                  width={width}
                  sx={{ fontSize: layout.heroBodyFontSize }}
                />
              ))}
            </Box>
            <Skeleton
              variant="rounded"
              width={layout.buttonWidth}
              height={layout.buttonHeight}
              sx={{ marginTop: "32px", borderRadius: "999px" }}
            />
          </Box>
          <Skeleton
            variant="rounded"
            sx={{
              width: "100%",
              maxWidth: `${layout.heroArtMaxWidth}px`,
              height: "auto",
              aspectRatio: "1",
              marginX: "auto",
              borderRadius: "24px",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}
